<script>
import { OverlayManager } from "./overlay-manager.js";
export default {
  name: "OverlayBase",
  data() {
    return {
      doShow: false,
    };
  },
  methods: {
    setVisibility(visible) {
      this.doShow = visible;
      if (visible)
        document
          .getElementsByTagName("body")[0]
          .classList.add("mhi-overlay-open");
      else
        document
          .getElementsByTagName("body")[0]
          .classList.remove("mhi-overlay-open");
    },
  },
  watch: {
    "$route.path": {
      handler() {
        OverlayManager.closeAll();
      },
    },
  },
};
</script>
<template>
  <transition name="fade">
    <div v-show="doShow" ref="overlay-background" class="mhi-overlay"></div>
  </transition>
</template>
